import React from 'react'

const Fqa = () => {
  return (
    <div style={{marginTop:"80px"}}>Fqa</div>
  )
}

export default Fqa